<template>
  <div class="writeTemplate-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑笔记背景图</span>
        <span v-else>新增笔记背景图</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'writeTemplate' })"
        >
          {{ $t('commonMsg.back') }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t('commonMsg.save') }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="笔记背景图" class="pic">
            <div class="pic-item">
              <div class="writeTemplate-edit-cover">
                <img v-if="formData.file.url" :src="formData.file.url" />
                <i
                  v-else
                  class="writeTemplate-edit-cover-icon el-icon-plus"
                ></i>
                <div class="writeTemplate-edit-upload">
                  <el-upload
                    class="writeTemplate-edit-upload-btn"
                    action
                    :accept="'image/*'"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleAvatarChange"
                  >
                    <div
                      v-if="formData.file.url"
                      class="writeTemplate-upload-icon"
                    >
                      替换
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="编号" prop="number">
            <el-input v-model="formData.number"></el-input>
          </el-form-item>
          <el-form-item label="分类" prop="category" v-if="$route.query.usage">
            <el-radio-group v-model="formData.category">
              <el-radio label="CALLIGRAPHY">书法</el-radio>
              <el-radio label="WORK">工作</el-radio>
              <el-radio label="STUDY">学习</el-radio>
              <el-radio label="LIFE">生活</el-radio>
              <el-radio label="ART">艺术</el-radio>
              <el-radio label="OTHER">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="宽" prop="dpiW">
            <el-input v-model="formData.dpiW"></el-input>
          </el-form-item>
          <el-form-item label="高" prop="dpiH">
            <el-input v-model="formData.dpiH"></el-input>
          </el-form-item>
          <el-form-item label="型号(多种型号用\隔开)" prop="model">
            <el-input v-model="formData.model"></el-input>
          </el-form-item>
          <el-form-item label="设备型号组" prop="modelGroups">
            <el-checkbox-group v-model="formData.modelGroups">
              <el-checkbox
                v-for="item in modelData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="语言(多种语言用\隔开)" prop="lang">
            <el-input v-model="formData.lang"></el-input>
          </el-form-item>
          <el-form-item label="语言组" prop="langGroups">
            <el-checkbox-group v-model="formData.langGroups">
              <el-checkbox
                v-for="item in langData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            v-if="$route.query.usage && formData.usage === 'text'"
            label="HTML编码"
            prop="htmlCode"
          >
            <el-input
              type="textarea"
              :rows="8"
              placeholder="请输入内容"
              v-model="formData.htmlCode"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { uploadOss } from '@/utils/aliyun'
export default {
  data() {
    return {
      formData: {
        model: '',
        modelGroups: [],
        lang: '',
        langGroups: [],
        title: '',
        type: 'cloud',
        usage: '',
        category: '',
        number: '',
        dpiW: 0,
        dpiH: 0,
        htmlCode: '',
        file: {},
        apiVersion: ''
      },
      params: {},
      modelData: [],
      langData: [],
      rules: {
        // pic_address: [
        //   { required: true, message: "请选择广告封面", trigger: "change" }
        // ]
      },
      dataForm: null
    }
  },
  methods: {
    async handleAvatarChange(file, filtList) {
      this.dataForm = new FormData()
      this.dataForm.append('file', file.raw)

      this.$http.uploadWriteTemplate(this.dataForm).then((ret) => {
        this.formData.file = ret.data
      })
    },

    getWriteTemplateDetails() {
      this.$http.getWriteTemplatesDetails(this.$route.query.id).then((res) => {
        res.data.model = res.data.model.join('\\')
        res.data.lang = res.data.lang.join('\\')
        this.formData = Object.assign(this.formData, res.data)
      })
    },

    getModelGroups() {
      this.$http.getModelGroups().then((res) => {
        this.modelData = res.data.results
      })
    },
    getLangGroups() {
      this.$http.getLangGroups().then((res) => {
        this.langData = res.data.results
      })
    },

    save() {
      if (!this.dataForm) {
        this.dataForm = new FormData()
      }

      // 新增时判断是否添加笔记背景图
      if (
        !this.dataForm.get('file') &&
        !this.$route.query.id &&
        !this.$route.query.id
      ) {
        this.elMsg('请添加笔记背景图', 'error')
        return
      }

      this.params = Object.assign({}, this.formData)
      this.params.model = this.params.model.split('\\')
      this.params.lang = this.params.lang.split('\\')
      if (this.$route.query.id) {
        this.edit()
      } else {
        this.create()
      }
    },

    create() {
      this.$http.createWriteTemplates(this.params).then((res) => {
        this.formData.file = null
        this.elMsg('添加成功', 'success')
        this.$router.push({ name: 'writeTemplate' })
      })
    },

    edit() {
      this.$http
        .editWriteTemplates(this.$route.query.id, this.params)
        .then((res) => {
          this.file = null
          this.elMsg('编辑成功', 'success')
          this.$router.push({ name: 'writeTemplate' })
        })
    }
  },
  mounted() {
    if (this.$route.query.usage) {
      this.formData.usage = this.$route.query.usage
    }
    this.formData.apiVersion = !this.$route.query.usage ? 'v1' : 'v2'
    this.getModelGroups()
    this.getLangGroups()
    if (this.$route.query.id) {
      this.getWriteTemplateDetails()
    }
  }
}
</script>

<style lang="scss">
.writeTemplate-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .writeTemplate-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .writeTemplate-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .writeTemplate-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .writeTemplate-edit-upload-btn {
              display: block;
            }
          }
          .writeTemplate-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
